import { render, staticRenderFns } from "./CoreBarProfile.vue?vue&type=template&id=ef674a28&scoped=true&"
import script from "./CoreBarProfile.vue?vue&type=script&lang=js&"
export * from "./CoreBarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef674a28",
  null
  
)

export default component.exports